<template>
  <swiper
    :modules="[Autoplay, Pagination, EffectCreative]"
    :autoplay="{
      delay: 3500,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    }"
    :pagination="{ type: 'progressbar' }"
    :creative-effect="{
      prev: {
        shadow: true,
        translate: ['-20%', 0, -1],
      },
      next: {
        translate: ['100%', 0, 0],
      },
    }"
    :style="{ '--swiper-pagination-color': '#ed1c24' }"
    :loop="!!items.length"
    effect="creative"
    @swiper="(swiper) => carousel = swiper"
  >
    <q-resize-observer @resize="onResize" />
    <!-- eslint-disable @stylistic/max-len -->
    <div
      v-if="items.length"
      class="q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--horizontal absolute flex flex-center z-top gt-sm"
    >
      <q-btn
        :icon="mdiChevronLeft"
        color="primary"
        flat
        round
        dense
        @click="carousel?.slidePrev()"
      />
    </div>
    <div
      v-if="items.length"
      class="q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--horizontal absolute flex flex-center z-top gt-sm"
    >
      <q-btn
        :icon="mdiChevronRight"
        color="primary"
        flat
        round
        dense
        @click="carousel?.slideNext()"
      />
    </div>
    <!-- eslint-enable @stylistic/max-len -->
    <swiper-slide>
      <HomeBanner />
    </swiper-slide>
    <swiper-slide
      v-for="item in items"
      :key="item.id"
    >
      <StrapiBanner
        :banner="item.attributes"
        :small
      />
    </swiper-slide>
  </swiper>
</template>

<script lang="ts" setup>
import type SwiperClass from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination, EffectCreative } from 'swiper/modules';
import { mdiChevronLeft, mdiChevronRight } from '@quasar/extras/mdi-v7';
import type { Slider } from '~/types/strapi';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-creative';

const { screen } = useQuasar();
const { findOne } = useStrapi();
const carousel = ref<SwiperClass | null>(null);
const small = ref(false);

const { data, execute } = await useAsyncData(
  'home_slider',
  () =>
    findOne<Slider>('sliders', '1', {
      populate: [
        'banners.small',
        'banners.large',
        'banners.content',
        'banners.cta',
      ] as never,
    }),
  {
    immediate: false,
    lazy: true,
    getCachedData: getCachedPayload,
  },
);

const items = computed(() =>
  data.value?.data.attributes.banners?.data?.filter(e => e.attributes.publishedAt != null) ?? []);

watch(items, () => carousel.value?.update());

const onResize = (size: { width: number; height: number }) =>
  small.value = size.width < screen.sizes.md;

onInteraction(() => execute());
</script>
